import common from './common.json';

export const de = {
  common
};
